import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CommentForm extends Component {

  constructor(props) {
    super(props);

    this.state = { value: '' };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const value = this.state.value;
    if (value && value.length > 0) {
      this.props.onCommentFormSubmitted(value);
    }
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <textarea onChange={this.handleChange} value={this.state.value} />
        <input type="submit" value="Post" />
      </form>
    );
  }
}

CommentForm.propTypes = {
  onCommentFormSubmitted: PropTypes.func.isRequired
}

export default CommentForm;


// WEBPACK FOOTER //
// ./src/views/commentForm.js